import {
	ButtonBase,
	type ButtonBaseProps,
	type SxProps,
	type Theme,
	useTheme,
} from "@mui/material";
import type { FC, ReactNode } from "react";

interface TimelineRowButtonProps extends Omit<ButtonBaseProps, "children"> {
	isLast?: boolean;
	backgroundColor?: string;
	dividerColor?: string;
	children: ReactNode;
	sx?: SxProps<Theme>;
}

export const TimelineRowButton: FC<TimelineRowButtonProps> = ({
	isLast = false,
	backgroundColor,
	dividerColor,
	sx,
	children,
	...rest
}) => {
	const theme = useTheme();
	const base: SxProps<Theme> = {
		width: "100%",
		justifyContent: "stretch",
		textAlign: "left",
		borderRadius: 0,
		backgroundColor: backgroundColor ?? theme.palette.common.white,
		"&:active": { transform: "scale(0.99)" },
		...(!isLast && {
			borderBottom: `1px solid ${dividerColor ?? theme.palette.grey[100]}`,
		}),
	};

	return (
		<ButtonBase
			{...rest}
			sx={[base, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
		>
			{children}
		</ButtonBase>
	);
};
